import React, { useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFolder } from '@fortawesome/pro-light-svg-icons';

import $image_url from 'js/utils/image_url';
import { currentUser } from 'js/utils/user';
import PremiumIcon from 'js/premium/PremiumIcon';
import { ReaderMessageContext } from 'js/liswp/work_actions/ReaderMessageContext';
import { Author } from 'js/liswp/types';
import { showBulkDownloadModal } from 'js/bulk_download/show_bulk_download_modal';
import { BulkDownloadFilterCounts } from 'js/bulk_download/bulk_download_helper';

// TODO: This Typescript declaration automatically generates the BulkDownloadButtonPrefix type,
// in a much preferable, automatic way. Unfortunately it causes Astroturf to choke on the file,
// because it doesn't understand the `infer` keyword. Update this once Astroturf is removed.

// import { BulkDownloadTrigger } from 'js/bulk_download/bulk_download_helper';

// type ExtractBulkDownloadButtonKeys<T> =
//   T extends `${infer Prefix}-bulk-download-button` ? Prefix : never;
// export type BulkDownloadButtonPrefix =
//   ExtractBulkDownloadButtonKeys<BulkDownloadTrigger>;

type BulkDownloadButtonPrefix =
  | 'swp'
  | 'swp-sticky-header'
  | 'news-feed'
  | 'search-results'
  | 'library';

interface Attachment {
  downloadUrl: string;
  id: number;
}

// TODO: Consolidate with top_card_presenter work type, Paper type in js/social/shared/types
interface Work {
  id: number;
  title: string;
  slug: string;
  downloadableAttachments: Attachment[];
  authors: Author[];
  bulkDownloadPurchased?: boolean;
  filterCounts?: BulkDownloadFilterCounts;
}

interface BulkDownloadButtonProps {
  source: BulkDownloadButtonPrefix;
  work: Work;
  premium?: boolean;
  showSearchRedesign?: boolean;
}

const BulkDownloadButton: React.FC<BulkDownloadButtonProps> = ({
  source,
  work,
  premium = false,
  showSearchRedesign = false,
}) => {
  const topCardContext = useContext(ReaderMessageContext);

  if (!work.downloadableAttachments[0]) {
    return null;
  }

  const renderBulkDownloadModal = () => {
    const attachment = work.downloadableAttachments[0];
    showBulkDownloadModal({
      trigger: `${source}-bulk-download-button`,
      gatedDownload: true,
      work: {
        id: work.id,
        slug: work.slug,
        title: work.title,
        attachment: { url: attachment.downloadUrl, id: attachment.id },
        authors: work.authors,
      },
      purchased: !!work.bulkDownloadPurchased,
      readerMessageLimitReached: topCardContext.readerMessageLimitReached,
      setReaderMessageLimitReached: topCardContext.setReaderMessageLimitReached,
    });
  };

  return (
    <button
      className={
        showSearchRedesign
          ? 'work-card--show-search-redesign'
          : 'work-card--action-button-secondary'
      }
      onClick={renderBulkDownloadModal}
    >
      {showSearchRedesign ? (
        <FontAwesomeIcon
          style={{ marginRight: 6, width: 13, height: 13 }}
          icon={faFolder}
        />
      ) : premium || currentUser?.premium || work.bulkDownloadPurchased ? (
        <img
          src={$image_url('icons/download_folder.svg')}
          style={{ marginRight: 6, width: 16 }}
        />
      ) : (
        <PremiumIcon />
      )}
      <div>
        {showSearchRedesign ? 'Download Full PDF Package' : 'Bulk Download'}
      </div>
    </button>
  );
};

export default BulkDownloadButton;
